import e from"styled-components";const i=e.div`
	box-shadow: 0px 0.633px 3.163px 0px rgba(63, 65, 66, 0.2);
	border-radius: ${({borderRadius:e})=>`${e}px`};
	background-color: #000;
	border: 0.71px solid ${({theme:e})=>e.border.black10};
	display: flex;
	flex-direction: ${({isOneColumn:e})=>e?"row":"column"};
	justify-content: ${({isOneColumn:e})=>e?"flex-start":"space-between"};
	height: 100%;
`,o=e.div`
	background: url(${({imageUrl:e})=>e});
	background-size: cover;
	background-position: ${({position:e})=>e?`${e.x}% ${e.y}%`:"center"};
	border-radius: ${({borderRadius:e})=>`${e}px`};
	position: relative;

	${({isOneColumn:e})=>e?"\n      width: 284px;\n      height: 241px;\n      ":"\n      height: 170px;\n  "}
`,n=e.div`
	background: linear-gradient(
		${({isOneColumn:e})=>e?"90deg":"180deg"},
		rgba(0, 0, 0, 0) 0%,
		rgba(0, 0, 0, 0.2) 48.34%,
		#000 93.86%
	);
	position: absolute;
	inset: 0;
`,t=e.div`
	display: flex;
	flex-direction: column;
	gap: 16px;
	position: relative;
	justify-content: ${({isOneColumn:e})=>e?"space-around":"flex-start"};
	padding: ${({isOneColumn:e})=>e?"24px 40px":"12px 14px"};
	flex: ${({isOneColumn:e})=>e?1:"0 0 auto"};
`,r=e.h1`
	margin: 0;
	color: white;
	max-width: 90%;
	font-weight: 500;
	font-size: ${({isOneColumn:e})=>e?"32px":"22px"};
	cursor: ${({isEditable:e=!1})=>e?"text":"default"};
`,a=e.div`
	display: flex;
	flex-direction: column;
	gap: ${({isOneColumn:e})=>e?"0px":"8px"};
`,d=e.p`
	margin: 0;
	font-size: 14px;
	line-height: 18px;
	color: #fafafa;
	width: 80%;
	white-space: pre-wrap;
	opacity: 0.6;
	cursor: ${({isEditable:e=!1})=>e?"text":"default"};
`,s=e.div`
	opacity: 0.5;

	${({isAbsolute:e})=>e&&"\n    position: absolute;\n    bottom: 12px;\n    right: 14px;\n  "}
`,l=e.span`
	padding: 5px 10px;
	font-size: 12px;
	color: ${({color:e})=>e};
	background: ${({background:e})=>e};
	border-radius: 9999px;
	width: fit-content;
	max-width: 80%;
	height: 26px;
	cursor: ${({isEditable:e=!1})=>e?"text":"default"};
	box-sizing: border-box;
	text-overflow: ellipsis;
	overflow: hidden;
	display: inline-block;
`,p=e.div`
	display: flex;
	justify-content: ${({hasLabel:e})=>e?"space-between":"end"};
	align-items: center;
`;export{s as CardArrowContainer,i as CardContainer,t as CardContentContainer,o as CardCover,p as CardFooter,a as CardHeader,r as CardHeading,l as CardLabel,n as CardOverlay,d as CardParagraph};
